import { render } from "./card-inner.vue?vue&type=template&id=4d034818"
import script from "./card-inner.vue?vue&type=script&lang=ts"
export * from "./card-inner.vue?vue&type=script&lang=ts"
script.render = render

export default script